import styled from '@emotion/styled'

import { breakpoints, Link, palette, spacing, Strong, typography } from 'main/ui'

export const SaveSearchFormContainer = styled.div`
  align-items: center;
  background-color: ${palette.whiteDove};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spacing.minorScale(5)}px ${spacing.majorScale(-3)}px;
  padding: ${spacing.minorScale(5)}px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    justify-content: space-between;
    margin: ${spacing.minorScale(5)}px 0;
    padding: ${spacing.minorScale(5)}px ${spacing.minorScale(5)}px;
  }
`

export const TextContainer = styled.div`
  margin: 0 ${spacing.majorScale(2)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: ${spacing.majorScale(1)}px;
    max-width: 516px;
  }
`

export const StyledText = styled(Strong)`
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 20px;
    line-height: 30px;
  }
`

export const StyledLink = styled(Link)`
  font-weight: ${typography.fontWeight.bold};

  @media (min-width: ${breakpoints.lg}px) {
    font-size: 20px;
  }
`

export const ButtonContainer = styled.div`
  margin-top: ${spacing.majorScale(3)}px;
  width: 320px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: 0;
    width: 250px;
  }
`
